import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  const title = "TENNIS CLUB";
  const subtitle = "Cheyres-Châbles";
  const [displayedTitle, setDisplayedTitle] = useState('');
  const [displayedSubtitle, setDisplayedSubtitle] = useState('');
  const [charIndex, setCharIndex] = useState(0);
  const [subtitleIndex, setSubtitleIndex] = useState(0);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    if (charIndex < title.length) {
      const timeout = setTimeout(() => {
        setDisplayedTitle(prev => prev + title[charIndex]);
        setCharIndex(prev => prev + 1);
      }, 80);
      return () => clearTimeout(timeout);
    } else if (subtitleIndex < subtitle.length) {
      const timeout = setTimeout(() => {
        setDisplayedSubtitle(prev => prev + subtitle[subtitleIndex]);
        setSubtitleIndex(prev => prev + 1);
      }, 60);
      return () => clearTimeout(timeout);
    }
  }, [charIndex, subtitleIndex]);

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Parallax Effect - Using real club image */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_tennis-cheyres/artifacts/gajw741p_TC%20Cheyres.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
        <div className={`transition-all duration-1000 transform ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          <h2 className="text-3xl md:text-5xl font-normal text-white mb-2 leading-tight tracking-widest uppercase">
            {displayedTitle}
            {charIndex < title.length && <span className="animate-pulse">|</span>}
          </h2>
          
          <h1 className="text-5xl md:text-8xl font-extrabold text-white mb-12 leading-tight tracking-wide">
            {displayedSubtitle}
            {charIndex >= title.length && subtitleIndex < subtitle.length && <span className="animate-pulse">|</span>}
          </h1>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-wrap justify-center gap-4 mt-12">
          <a
            href="http://tccheyres.plugin.ch/user/dashboard"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 bg-green-600 hover:bg-green-700 text-white rounded-xl font-bold text-lg transition-all hover:scale-105 shadow-lg"
          >
            RÉSERVATIONS
          </a>
          <a
            href="http://tccheyres.plugin.ch/user/signup"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 bg-purple-600 hover:bg-purple-700 text-white rounded-xl font-bold text-lg transition-all hover:scale-105 shadow-lg"
          >
            DEVENIR MEMBRE
          </a>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 md:bottom-20 left-1/2 transform -translate-x-1/2 animate-bounce">
          <ChevronDown className="w-8 h-8 text-white/70" />
        </div>
      </div>
    </section>
  );
};

export default Hero;